<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Certifikati</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
        <p>
        V iskalnik vnesite številko certifikata ali priimek pridelovalca ali naziv predelovalca. Nato kliknete na ikono iskalne lupe ali pritisnete tipko "Enter". S pritiskom na ikono certifikata, v stolpcu »Poglej« si lahko ogledate certifikat.
      </p>
         <div>
            <form @submit.prevent="handleSubmit" class="k-form">
          <!-- <span>Številka certifikata, priimek pridelovalca ali naziv predelovalca</span> -->
               <div class="display-flex">
               <input type="text" v-model="isci" placeholder="Številka certifikata, priimek pridelovalca ali naziv predelovalca" name="isci" id="isci" class="k-textbox k-textboxlong" v-on:keyup.enter="isciCertifikat" />
                 <span class="input-icon-search" @click="isciCertifikat"><font-awesome-icon  icon="search"/></span>
            </div>
        
     
    </form>
    
        </div>
    
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
    <div class="grid-wrapper">
    <Grid  
                       
                        :sortable="sortable"
                        :filterable="filterable"
                     
                         :pageable="false"
                        :data-items="dataResult"
                        :skip="skip"
                        :take="take" 
                        :sort="sort" 
                        :resizable="true"
                      
                      
                        :columns="columns"
                        @datastatechange="dataStateChange"

                        
                       
                        @pagechange="pageChangeHandler"
                       
                        
                                              

                         
                        
                                               >
                 
                     <template v-slot:cbItem="{props}">
                        <td class="link"   title="Certifikat">
                       <router-link :to="{ name: 'certifikatJavno',params:{certifikatid:props.dataItem.id}}"  target="_blank">
                                                 <font-awesome-icon size="2x" icon="file-contract"/>
                        </router-link>
                      

                    
                    </td>
                    </template>
                      
                    </Grid>
                    <div class="shema-loader" v-if="loading"><font-awesome-icon icon="circle-notch" spin="spin"/></div>
                </div>

                    </div>
    </div>

</template>

<script>
//pageable "{ buttonCount: 4, pageSizes: [10,50,100,'all'] }"
import { mapState, mapActions } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { Grid, GridToolbar,GridNoRecords } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';

import { MultiSelect } from '@progress/kendo-dropdowns-vue-wrapper';
import CheckBoxGridItem from './support/CheckBoxGridItem';
Vue.component('kendo-multiselect', MultiSelect);


import { process } from '@progress/kendo-data-query';

 





export default {
  props:['isci'],
   components:{
      'dropdownlist': DropDownList,
      'cbItem': CheckBoxGridItem,
  //    'sifkontroleddcell': SifrantKontroleDownCell,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
 
  },
    data () {
        return {
         
           
          
         
            


          
            editID: null,
            skip: 0,
            take: 10,
            pageSize: 10,
            sortable: true,
            filterable: false,
            groupable: false,
            dataResult: [],
            loading:false,
         
            sort: [
                { field: 'datumizdaje', dir: 'asc' }
            ],
            columns: [
       
                { field: "stevilkacertifikata", filterable:false, title:"Številka certifikata",width: "170px",footerCell:this.nogaNazivVsot},
                 
                 // { field: "veljaven", title:"Veljaven",width: "100px",cell:"cbItem",hidden:true},
          
                
               
                 { field: "imenosilca", title:"Nosilec",filterable:false},
                //{ field: "kmgmid", title:"KMG-MID",width: "150px",footerCell: this.nogaStMidov},
//                  { field: "kontrolnastevilka", title:"Kontrolna št.",width: "150px"},
  //              { field: "statuspridelovalca", title:"Status",width: "150px"},
    //            { field: "postnastevilka", title:"Poštna številka"},
                { field: "posta", title:"Pošta",filterable:false,width: "250px"},
        //        { field: "obcina", title:"Občina"}, 
                { field: "datumizdaje", title:"Datum izdaje",width: "120px",filterable:false, type:"date",format:"{0:d}"},
                { field: "datumveljavnosti", title:"Datum veljavnosti",width: "120px",filterable:false, type:"date",format:"{0:d}"},
                { field: "id", title:"Poglej",width: "120px",filterable:false,cell: 'cbItem'},
        //        { field: "statisticnaregija", title:"Statistična regija"},
                
           
            ],
          

           

        }
    },
    created () {

        this.naloziPodatke(this.isci);
     
 
    },
    beforeRouteUpdate (to, from,next) {
    
    this.naloziPodatke(to.params.isci,next);

   

},
    computed: {
         hiddenColumns() {
            return this.columns.filter(c=>c.hidden);
        },
...mapState('users', ['userDetails','sezoneBranje']),
         ...mapState({gridData(state) {
      
          return state.certifikat.certifikat;
        }}),         
    
           },
      watch: {
        skip(newValue, oldValue){
            console.log(`Updating from ${oldValue} to ${newValue}`);

            const dataState = {
            skip: this.skip,
            take: this.take,
            filter: this.filter,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);
        },
        take(newValue, oldValue){
            console.log(`Updating from ${oldValue} to ${newValue}`);
            
            const dataState = {
                skip: this.skip,
                take: this.take,
              //  filter: this.filter,
                sort: this.sort,
                group: this.group
            }
        this.dataResult = process( this.gridData, dataState);
        },
       gridData(newValue, oldValue) {
  

      if(newValue){
        const dataState = {
            skip: this.skip,
            take: this.take,
            //filter: this.filter,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);

        }
    }
},
    methods: {
        naloziPodatke: function(isci,next){
            this.loading=true;
         
            this.isciVse({isci:isci}).then(()=>{

                this.loading=false;
            if(next)
                next();
            });

           
        },
        isciCertifikat(e){
          this.clearAlert();
          if(!this.isci) {
              this.errorAlert("Vnesti morate iskalni niz!")
              return;
              }
          if(this.isci.length<3) {
              this.errorAlert("Iskalni niz mora biti dolg vsaj 3 znake")
              return;
              }
          
           this.$router.push({ name: 'certifikatiJavno', params: { isci: this.isci } })
        

        },
        ...mapActions({clearAlert: 'alert/clear'}),
        ...mapActions({errorAlert: 'alert/error'}),
        ...mapActions('certifikat', ['isciVse']),
        poglejCertifikat: function(e,d){

                console.log(d.dataItem.id);
                //router pa idi naložit pokaži en certifikat!!!
        },
        skrijStolpec: function(e) {
            let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=true;
                const dataState = {
            skip: this.skip,
            take: this.take,
            filter: this.filter,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);
           
        },

        prikaziStolpec: function(e) {
           let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=false;
                const dataState = {
            skip: this.skip,
            take: this.take,
            filter: this.filter,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);
        },
        nogaNazivVsot: function (h, emptyElement , props, listeners ) {
            return h('span', {}, ['Število:']);
        },
        nogaSteviloCertifikatova: function (h, emptyElement , props, listeners ) {
          if(this.dataResult.data)
            return h('span', {}, [kendo.toString(this.dataResult.data.length,"n0")]);
        },
       
        nogaStMidov: function (h, emptyElement , props, listeners ) {
          if(this.dataResult.data){
            var counts = {};
                for (var i = 0; i < this.dataResult.data.length; i++) {
                     counts[this.dataResult.data[i][props.field]] = 1 + (counts[this.dataResult.data[i][props.field]] || 0);
                }
                 return h('span', {}, [kendo.toString(Object.keys(counts).length,"n0")]);
            }
           
        },
        formatDate: function (h, emptyElement , props, listeners ) {
        
            return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
    

      
       
        
        createAppState: function(dataState) {
            console.log("createAppState");
            this.take = dataState.take;
            this.skip = dataState.skip?dataState.skip:0;
            this.group = dataState.group;
            this.filter = dataState.filter;
            this.sort = dataState.sort;
           
        },

        dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
         
            this.dataResult = process(this.gridData, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });
         

        },
      
       
        
     
        pageChangeHandler: function(event) {
            console.log(event);
            this.skip = event.page.skip;
            this.take = event.page.take;
           
        }
        
    }
};
</script>

